import { useState } from 'react';
import { exportChatPdf } from '../api';
import { downloadBlob } from '../lib/download-blob';
import { getExportErrorMessage } from '../lib/get-export-error-message';

export const useExportChatPdf = ({ onError }) => {
	const [isExporting, setIsExporting] = useState(false);

	const exportPdf = async () => {
		setIsExporting(true);
		try {
			const { blob, filename } = await exportChatPdf();
			downloadBlob(blob, filename);
		} catch (error) {
			console.error('Export PDF failed:', error);
			onError(await getExportErrorMessage(error));
		} finally {
			setIsExporting(false);
		}
	};

	return { exportPdf, isExporting };
};
